import { HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
} from '../../../../../../../../components/TableContent';

interface SkeletonMobileProps {}

export const SkeletonMobile: React.FC<SkeletonMobileProps> = () => {
  return (
    <TableContent direction="column" space={Spacing['inline.xxxs']}>
      <HStack justifyContent="space-between" w="full">
        <VStack space={Spacing['stack.quarck']} flex={1}>
          <Skeleton
            w="80%"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w="50%"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </VStack>
        <HStack space={Spacing['inline.nano']}>
          <Skeleton
            w={Spacing['inline.xs']}
            h={Spacing['inline.xs']}
            borderRadius={BoxRadius.circular}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w={Spacing['inline.xs']}
            h={Spacing['inline.xs']}
            borderRadius={BoxRadius.circular}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w={Spacing['inline.xs']}
            h={Spacing['inline.xs']}
            borderRadius={BoxRadius.circular}
            endColor={Color['brand.primary.lightest']}
          />
        </HStack>
      </HStack>
      <HStack
        w="full"
        space={Spacing['stack.quarck']}
        alignItems="center"
        flex={1}
        justifyContent="space-between">
        <Skeleton
          w="30%"
          h={Typography['fontsize.lg']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
        <Skeleton
          w="40%"
          h={Spacing['inline.xxs']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </HStack>
      <HStack
        space={Spacing['stack.quarck']}
        alignItems="center"
        w="full"
        justifyContent="space-between">
        <TableContentItemColumn maxW="150px" space={Spacing['inline.quarck']}>
          <Skeleton
            w="60%"
            h={Typography['fontsize.xs']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w="70%"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w="full"
            h={Typography['fontsize.xs']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </TableContentItemColumn>
        <Skeleton
          w="40px"
          h="40px"
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </HStack>
    </TableContent>
  );
};
